import { convexQuery, useConvexMutation } from "@convex-dev/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import type { Id } from "@teachloop/backend/_generated/dataModel";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Text, View } from "react-native";
import { AppBar } from "../ui/app-bar";
import { api } from "../utils/convex-api";
import goBack from "../utils/go-back";
import LessonHistorySubjectList from "./lesson-history-subject-list";
import TutorLessonHistoryList from "./tutor-lesson-history-list";

function TutorLessonHistory() {
  const { data: lessonHistorySubjects = [] } = useQuery(
    convexQuery(api.tutor.lessonHistory.queries.getLessonReportSubjects, {}),
  );

  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;

  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);

  const { data: lessonReports = [] } = useQuery(
    convexQuery(
      api.tutor.lessonHistory.queries.getLessonReports,
      selectedSubjectId
        ? {
            subjectId: selectedSubjectId,
          }
        : "skip",
    ),
  );

  const { mutateAsync: processLessonReport } = useMutation({
    mutationFn: useConvexMutation(api.tutor.home.mutations.processLessonReport),
  });

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  const renderListHeaderComponent = useCallback(
    () => (
      <View className="mx-5">
        <View className="h-2" />
        <View className="gap-1">
          <Text className="text-[28px] text-gray-800 leading-[1.2] font-medium font-zilla-slab-medium">
            Lesson history
          </Text>
          <Text className="text-xl font-geologica-regular font-normal leading-[1.5] text-gray-800">
            View all previous lesson reports here
          </Text>
        </View>

        <View className="h-8" />

        <LessonHistorySubjectList
          lessonHistorySubjects={lessonHistorySubjects}
          selectedSubjectId={selectedSubjectId}
          setSelectedSubjectId={setSelectedSubjectId}
        />

        <View className="h-4" />
      </View>
    ),
    [lessonHistorySubjects, selectedSubjectId],
  );

  return (
    <Fragment>
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Back</AppBar.Title>
      </AppBar>

      <TutorLessonHistoryList
        lessonReports={lessonReports}
        ListHeaderComponent={renderListHeaderComponent}
        onProcessLessonReport={processLessonReport}
      />
    </Fragment>
  );
}

export default TutorLessonHistory;
